import React from "react";
import "../assets/css/app.css";
import "../assets/css/custom.css";  // Ensure these paths are correct
import "../assets/css/responsive.css";


const contentMap = {
    1: `
     <div class="img-h2">
         <h2>Free Ring Sizer</h2>
      <img src="assets/img/free_ring_sizer1.jpg" alt="">
        </div>
     <div class="text-center">
         <p>We are happy to send you a complimentary plastic ring sizer so that you can easily measure your ring size at home.</p>
      
      <button class="free-sz-btn">Request Free Sizer</button> 
      </div>
      <div class="img-h2">
         <h2>
            Ring Size Guide
            </h2>
      <img src="assets/img/ring_size_guide.jpg" alt="">
        </div>
     <div class="text-center">
         <p>
            If you would like to determine your ring size immediately, we suggest that you print our simple Ring Sizing Guide and read the instructions carefully. Before you print, be sure to check that page scaling is set to "none" on your print dialog box. In order to view this guide, you will need to use Adobe Acrobat Reader. Download it for free.
            </p>
      
      <button class="free-sz-btn">Request Free Sizer</button> 
      </div>
    `,
    2: `
       <div class="img-shape">
        <h3>Shape</h3>
                      <div class="shape-img-container">
                        <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                         <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            
                        </div>
                         <div class="shape-img-container">
                        <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                         <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/round-popup.svg" alt="">
                            <p>Round</p>
                            </div>
                            
                        </div>
        </div>
    
    `,
    3: `
       <div class="img-shape">
        <h3>Lab-Created Diamonds</h3>
        <p>
            Chemically and visually identical to the natural variety, yet with a different origin. Our lab-created diamonds are as their name suggests - created in a lab. Each lab-created diamond starts life as a tiny carbon seed that is exposed to extreme heat and pressure, mimicking the natural method of diamond formation. Once grown (usually within six to ten weeks), it is then cut and polished to reveal a beautiful lab-created diamond.
            </p>
                      <div class="shape-img-container">
                        <div class="shape-img-content">
                            <img src="assets/img/step-1.jpg" alt="">
                            <p>Step 1</p>
                            <p>
                                Diamond Seed
                                </p>
                            </div>
                         <div class="shape-img-content">
                            <img src="assets/img/step-1.jpg" alt="">
                            <p>Step 2</p>
                            <p>Apply Heat & Pressure</p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/step-1.jpg" alt="">
                            <p>Step 3</p>
                            <p>
                                The Diamonds Grow
                                </p>
                            </div>
                            <div class="shape-img-content">
                            <img src="assets/img/step-1.jpg" alt="">
                            <p>Step 4</p>
                            <p>
                                Diamond is Ready
                                </p>
                            </div>
                            
                            
                        </div>
                        
        </div>
    `,
    4: `
      <div class="img-h2">
         <h2>Clarity</h2>
      <img src="assets/img/free_ring_sizer1.jpg" alt="">
        </div>
     <div class="text-center">
         <p style="">
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.

            </p>
      </div>
     
    `,
    5: `
      <div class="img-h2">
         <h2>Color</h2>
      <img src="assets/img/free_ring_sizer1.jpg" alt="">
        </div>
     <div class="text-center">
         <p style="">
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            
            </p>
      </div>
     
    `,
    6: `
      <div class="img-h2">
         <h2>Certificate</h2>
      <img src="assets/img/free_ring_sizer1.jpg" alt="">
        </div>
     <div class="text-center">
         <p style="">
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            
            </p>
      </div>
     
    `,
    9: `
      <div class="img-h2">
         <h2>Band Width</h2>
      <img src="assets/img/free_ring_sizer1.jpg" alt="">
        </div>
     <div class="text-center">
         <p style="">
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            A diamond's clarity refers to the presence of impurities within the stone, when a rough stone is extracted from carbon deep beneath the earth, tiny elements are almost always inside.
            
            </p>
      </div>
     
    `
  };


const PopupComponent = ({ isOpen, contentId, onClose }) => {
  if (!isOpen) return null; // Ensures popup doesn't render when closed

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        <div dangerouslySetInnerHTML={{ __html: contentMap[contentId] || "<p>No content available</p>" }} />
      </div>
    </div>
  );
};

export default PopupComponent;

